import apiClient from './client'

export interface FbStatus {
  connected: boolean
  app_configured?: boolean
  app_id?: string
  ad_account_id?: string
  page_id?: string
}

export interface MetaAppConfig {
  configured: boolean
  app_id?: string
}

export interface AdAccount {
  id: string
  name: string
  account_status: number
}

export const getFbStatus = (): Promise<FbStatus> =>
  apiClient.get('/facebook/status').then((r) => r.data)

export const getMetaAppConfig = (): Promise<MetaAppConfig> =>
  apiClient.get('/facebook/app-config').then((r) => r.data)

export const saveMetaAppConfig = (app_id: string, app_secret: string): Promise<MetaAppConfig> =>
  apiClient.post('/facebook/app-config', { app_id, app_secret }).then((r) => r.data)

export const getFbAdAccounts = (): Promise<{ ad_accounts: AdAccount[] }> =>
  apiClient.get('/facebook/ad-accounts').then((r) => r.data)

export const selectFbAccount = (ad_account_id: string, page_id?: string) =>
  apiClient.post('/facebook/select-account', { ad_account_id, page_id }).then((r) => r.data)

export const disconnectFb = () =>
  apiClient.delete('/facebook/disconnect').then((r) => r.data)

export const getFbConnectUrl = (): string => {
  const base = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8000'
  const token = localStorage.getItem('token') ?? ''
  return `${base}/facebook/connect?token=${encodeURIComponent(token)}`
}
